import React from "react";
import { Spin } from "antd";
import "./style.css";

const index = () => {
  
  // function openChild(value) {
  //   const promise1 = new Promise((resolve, reject) => {
  //     console.log("promised");
  //     const { url } = value;
  //     const iframeE: any = document.querySelector("#myId");

  //     resolve(iframeE.contentWindow);
  //   });

  //   promise1.then((res: any) => {
  //     let msg = value;
  //     setTimeout(() => {
  //       res.postMessage(msg, "*");
  //       console.log(msg, "msg post");
  //     }, 1000);
  //     // res.focus();
  //   });
  // }

  // useEffect(() => {
  //   openChild({
  //     url: "http://39.104.136.10:3013",
  //     username: "lianpf",
  //     password: "12345678q",
  //   });
  // }, []);
  // return (
  //   <Iframe
  //     url="http://39.104.136.10:3013"
  //     id="myId"
  //     className="myClassname"
  //     position="relative"
  //   />
  // );
  return (
    <div id="orderEdi">
      <div className="order_dom">
      <Spin></Spin>
      </div>
    </div>
  )
};

export default index;
